export enum JobInformationAttributeKeysType {
    JobNumberKey = 'job-number-key',
    JobTypeKey = 'job-type-key'
}
